import styled from 'styled-components';

export const Button = styled.button`
  ${props => props}
  font-weight: ${props => props.theme.old.fonts.weight.semibold};
  border-radius: ${props => props.rounded ? props.theme.old.rounded[props.rounded] : props.size === "small" ? props.theme.old.rounded[6] : props.theme.old.rounded[8]};
  font-size: ${props => props.size === "small" ? props.theme.old.fontSize[12] : props.theme.old.fontSize[16]};
  font-family: ${props => props.theme.old.fonts.family.primary};
  transition: ${props => props.theme.old.transition.default};
  outline: none;
  border: none;
  cursor: ${props => !props.disable && 'pointer'};
  /* cursor: pointer; */
  width: ${props => props.width || props.size === "small" ? "133px" : '180px'};
  max-width: 100%;
  height: ${props => props.height || props.size === "small" ? "36px" : '48px'};
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  user-select: none;
  padding: ${props => props.padding || `0 ${props.theme.old.spacing[32]}`};
  /* text-transform: capitalize; */

  :hover {
    box-shadow: ${props => !props.disable && props.theme.old.shadow.button.hover};
    background-color: ${props => props.theme.old.colors[props.hoverBg]};
  }

  :active {
    box-shadow: ${props => props.theme.old.shadow.button.active};
  }
`;

export const Primary = styled(Button)`
  ${props => props}
  background-color: ${props => props.theme.old.colors[props.bg] || props.theme.old.colors[props.disable ? "purpleIllutionist2" : props.invert ? "white" : "sweetScape"]};
  color: ${props => props.theme.old.colors[props.color] || props.theme.old.colors[props.invert ? "sweetScape" : "white"]};
`;

export const Secondary = styled(Button)`
  ${props => props}
  background-color: ${props => props.theme.old.colors[props.bg] || props.theme.old.colors.placeboPurple};
  color: ${props => props.disable ? props.theme.old.colors.gray[500] : props.theme.old.colors[props.color] || props.theme.old.colors.sweetScape};
`;

export const Outline = styled(Button)`
  ${props => props}
  border: 2px solid ${props => props.checked ? props.theme.old.colors.sweetScape : props.theme.old.colors.aircraftWhite};
  background-color: ${props => props.theme.old.colors.transparent};
  color: ${props => props.checked ? props.theme.old.colors.sweetScape : props.theme.old.colors[props.color] || props.theme.old.colors.moreThanAWeek};
  box-shadow: none;

  :hover {
    border: 2px solid ${props => props.checked ? props.theme.old.colors.sweetScape : props.theme.old.colors.aircraftWhite};
    box-shadow: none;
    background-color: ${props => props.theme.old.colors[props.hoverBg] || props.theme.old.colors.bleachedSilk};
  }

  :active {
    background-color: ${props => props.theme.old.colors.coldMorning};
  }

  input {
    display: none;
  }
`;